import styled from '@emotion/styled';
import { SmallText, Text } from 'ds/components/typography';
import { typographyLineHeightCfg } from 'ds/components/typography/types';


export const DescriptionWrapper = styled(Text)`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    max-width: 740px;
    line-height: ${typographyLineHeightCfg.h3.desktop}px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    max-width: 600px;
  `}
`;

export const AwardsWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    display: flex;
    margin: 0 -${theme.spacing(0.5)};
  `}
`;

export const AwardInner = styled.div`
  white-space: normal;
`;

export const AwardItemRoot = styled.div`
  > a, a:active, a:hover {
    color: initial;
    text-decoration: none;
  }
`;

export const AwardItemWrapper = styled.div`
${({ theme }) => `
    display: flex;
    align-items: center;
    background-color: ${theme.colors.neutrals.grey11};
    border-radius: ${theme.borderRadius.small};
    direction: rtl;
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    width: 280px;
    min-width: 280px;
    height: 116px;
    margin: 0 ${theme.spacing(0.5)};
    padding: ${theme.spacing(2)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    height: 120px;
    margin: 0 auto ${theme.spacing(1)};
    padding: ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(4)};
  `}
`;

export const AwardImage = styled.div`
  ${({ theme }) => `
    width: 82px;
    min-width: 82px;
    height: 82px;
    margin-left: ${theme.spacing((2))};

    > img {
      width: 100%;
      height: 100%;
    }

    > svg {
      margin: 0 auto;
      display: flex;
    }
  `}
`;

export const MainInfoWrapper = styled.div<{ showCounters: boolean; }>`
  ${({ showCounters }) => `
    ${showCounters ? `
      display: flex;
      justify-content: space-between;
    ` : ''}
  `}
  ${({ theme }) => theme.media.showAt({ at: 2 })`
    margin-top: ${theme.spacing(5)};
  `}
`;

export const ProjectCountersWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    display: flex;
    justify-content: space-between;
  `}
`;

export const ProjectCounterItem = styled.div<{ isClickable?: boolean }>`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    display: flex;
    margin-top: ${theme.spacing(3)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(0.5)};
  `}

  ${({ isClickable }) => `
    ${isClickable && `
      &:hover {
        cursor: pointer;
      }
    `}
  `}
`;

export const ProjectCounterNumber = styled(Text)`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: 32px;
    line-height: 32px;
    color: ${theme.colors.brand.madlanGreen};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    display: inline;
  `}
`;

export const ProjectCounterDescription = styled(SmallText)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    display: inline;
    margin-right: ${theme.spacing(0.25)};
  `}
`;

export const ProjectCounterItemInner = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin-right: ${theme.spacing(3)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    text-align: center;
    margin-top: ${theme.spacing(1)};
  `}
`;

export const ProjectCounterIcon = styled.div`
  width: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const VideoWrapper = styled.div`
  ${({ theme }) => `
    position: relative;
    background-color: ${theme.colors.neutrals.grey6};
    border-radius: ${theme.borderRadius.small};
    overflow: hidden;
  `};
`;

export const VideoInner = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    position: relative;
    padding-bottom: 56.25%;
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-bottom: 55.05%;
  `}

  > iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`;

export const VideoAbsoluteFill = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

export const VideoPlaceholder = styled(VideoAbsoluteFill)`
  overflow: hidden;
`;

export const VideoPlaceholderBg = styled(VideoAbsoluteFill)`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  filter: blur(15px);
`;

export const ExpandButtonWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(1)} 0 0;
`;

export const ExpandButton = styled(Text)<{ isOpened: boolean }>`
  display: flex;
  align-items: center;
  ${({ theme, isOpened }) => `
    color: ${theme.colors.brand.main};
    svg {
      transform: rotate(${isOpened ? '180deg' : 0});
      margin-right: ${theme.spacing(0.25)};
      path {
        fill: ${theme.colors.brand.main};
      }
    }
  `}
`;
